var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScrollDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "rotate(90 10.5 10.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.406 6.177v8.335M14.824 10.095l-4.417 4.417-4.417-4.417",
    stroke: "#000",
    strokeWidth: 2
  })));
}

export default SvgScrollDown;